import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/transferOrderList';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import $U from 'plugins/tfs/platformConfigs/integrationMaps/urls';
import $S from 'theme/settings';
import React from 'react';
import { DatePicker, Input } from 'antd';
import { Link } from 'react-router-dom';
import { createURL } from 'utils';
import { dateFormatter, getStatusColor } from 'theme/utils';
import PrintButton from 'plugins/tfs/pages/oms/TransferOrderList/printableView';
import LayoutContentWrapper from 'components/ui-ant/utility/layoutWrapper.js';
import { DatatableBox } from 'components//ui-ant/Datatable';
import Block from 'components/ui-ant/Block';
import Box from 'components/ui-ant/utility/box';
import './style.css';

// pageContainer
import TransferOrderList from '_pageContainers/oms/TransferOrderList/main';

const TransferOrderListGrid = (pageContext) => {
  const {
    orderDate,
    barcode,
    sku,
    orderNumber,
    packageNumber,
    firstName,
    lastName,
    queryObject,
    statusId,
    selectedRowKeys,
    transferFilterBarRef,
    rowSelection,
    onTabChange,
    getStatuses,
    getEnumValue,
    handleChange,
    handleOrderDate,
  } = pageContext;

  const columns = [
    {
      key: 1,
      dataIndex: '',
      title: $ST.TABLE.COL.TRANSFER_NUMBER,
      render: (cellData) => {
        const { id, number } = cellData;
        return (
          <Link to={`${$R.TRANSFER_ORDER_DETAIL.path}/${id}`}>{number}</Link>
        );
      },
    },
    {
      key: 2,
      dataIndex: 'package_number',
      title: $ST.TABLE.COL.PACKAGE_NUMBER,
    },
    {
      key: 3,
      dataIndex: 'order_number',
      title: $ST.TABLE.COL.ORDER_NUMBER,
    },
    {
      key: 4,
      dataIndex: 'order_date_placed',
      title: $ST.TABLE.COL.ORDER_DATE,
      render: (cellData) => dateFormatter(cellData),
      sorter: true,
    },
    {
      key: 5,
      dataIndex: 'targetTransferDate',
      title: $ST.TABLE.COL.TARGET_TRANSFER_DATE,
      render: (cellData) => dateFormatter(cellData),
    },
    {
      key: 6,
      dataIndex: 'transferItemSet[0].product.sku',
      title: $ST.TABLE.COL.SKU,
    },
    {
      key: 7,
      dataIndex: 'state.name',
      title: $ST.TABLE.COL.TRANSFER_STATUS,
    },
    {
      key: 8,
      dataIndex: 'source.name',
      title: $ST.TABLE.COL.SOURCE_NAME,
    },
    {
      key: 9,
      dataIndex: 'destination.name',
      title: $ST.TABLE.COL.DESTINATION_NAME,
    },
  ];

  const buildStatusBoxes = () => {
    const statuses = getStatuses();
    if (statuses.length > 0) {
      localStorage.setItem(
        'localTransferOrderStatuses',
        JSON.stringify(statuses)
      );
    }
    let localTransferStatuses = JSON.parse(
      localStorage.getItem('localTransferOrderStatuses')
    );
    let mappedStatusesTransfer =
      statuses.length > 0 ? statuses : localTransferStatuses;
    return mappedStatusesTransfer !== null && mappedStatusesTransfer.length
      ? mappedStatusesTransfer.map(({ id, name, count }) => {
          const textStyle = { color: getStatusColor(id, 'transfer') };
          const clickedCardClass = statusId === id ? 'clicked-box-border' : '';

          return (
            <Block
              key={id}
              onClick={(e) => onTabChange(id)}
              className={`ant-col-lg-4 ant-col-md-6 ant-col-sm-12 ant-col-xs-24 small-card`}
            >
              <Box
                className={`stock-location--transfer-status ${clickedCardClass}`}
              >
                <Block
                  className='stock-location--status-name'
                  style={textStyle}
                >
                  {name}
                </Block>
                <Block className='stock-location--package-title'>
                  {$ST.PROCESS_COUNT}
                </Block>
                <Block
                  className='stock-location--status-count'
                  style={textStyle}
                >
                  {count || 0}
                </Block>
              </Box>
            </Block>
          );
        })
      : [];
  };

  return (
    <LayoutContentWrapper className='transfer-order-list mt45'>
      <Link className='breadcrumb-item' to='/oms/transfer-orders/'>
        {$ST.TRANSFER_ORDERS}
      </Link>
      {$S.isPackageOrderListPrintable && (
        <PrintButton
          url={$U.OMS.TRANSFER_ORDER_LIST}
          statusId={statusId}
          selectedRowKeys={selectedRowKeys}
          enumValue={getEnumValue()}
        />
      )}
      {
        <div className='transfer-status-boxes'>
          <div className='pb20'>{buildStatusBoxes()}</div>
        </div>
      }
      <div
        className='desktop-filters'
        id='desktopFilters'
        ref={transferFilterBarRef}
      >
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'> {$ST.FILTERS.ORDER_NUMBER}</p>
          <Input
            value={orderNumber}
            name='orderNumber'
            onChange={handleChange}
          />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'>{$ST.TABLE.COL.TRANSFER_NUMBER}</p>
          <Input
            value={packageNumber}
            name='packageNumber'
            onChange={handleChange}
          />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'>{$ST.FILTERS.CUSTOMER_NAME}</p>
          <Input value={firstName} name='firstName' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'>{$ST.FILTERS.CUSTOMER_LASTNAME}</p>
          <Input value={lastName} name='lastName' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'>{$ST.FILTERS.BARCODE}</p>
          <Input value={barcode} name='barcode' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'>{$ST.FILTERS.PRODUCT_SKU}</p>
          <Input value={sku} name='sku' onChange={handleChange} />
        </div>
        <div className='ant-col-xs-12 align'>
          <p className='bold bold-label'>{$ST.FILTERS.ORDER_DATE}</p>
          <DatePicker
            value={orderDate}
            size='medium'
            className='full-width'
            placeholder={$ST.SELECT_DATE}
            format='DD.MM.YYYY dddd'
            onChange={(date) => handleOrderDate(date)}
            showToday={false}
          />
        </div>
      </div>
      <DatatableBox
        rowKey='id'
        subtitle={$ST.ORDER_TRANSFERS}
        url={
          $U.BASE_URL + createURL($U.OMS.TRANSFER_ORDER_LIST, [], queryObject)
        }
        remote={true}
        exportable={false}
        columns={columns}
        rowSelection={rowSelection}
        locale={{ emptyText: $ST.TRANSFER_NOT_FOUND }}
        pagination
      />
    </LayoutContentWrapper>
  );
};

export default TransferOrderList(TransferOrderListGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/TransferOrderList/main/index.js